// src/components/header/headerMetrics.ts
// Single source for the sticky app header's height. AppHeader renders its main row at
// this height; anything that must pin BELOW the header (e.g. the use-case hub's utility
// bar) offsets by APP_HEADER_HEIGHT_PX instead of hard-coding a number.
// EA routes pass no breadcrumbs, so the header is the main row plus its 1px bottom border.
export const APP_HEADER_ROW_PX = 72;
export const APP_HEADER_HEIGHT_PX = APP_HEADER_ROW_PX + 1;
